/* eslint-disable max-len */
import { LOCALES } from 'i18n/locales';

export const generalIntl = {
    [LOCALES.ENGLISH]: {
        'general.signOut': 'Sign Out',
        'general.back': 'Back',
        'general.help': 'Help',
        disagree: 'Disagree',
        agree: 'Agree',
        decline: 'Decline',
        accept: 'Accept',
        retry: 'Retry',
        close: 'Close',
        dismiss: 'Dismiss',
        no: 'No',
        yes: 'Yes',
        ok: 'OK',
        errorLabel: 'Error',
        error: 'Sorry, we\'ve encountered an error, please try again',
        'general.error': 'Sorry, we\'ve encountered an error, please try again',
        loading: 'Loading',
        delete: 'Delete',
        'general.cancel': 'Cancel',
        'general.continue': 'Continue',
        'general.change': 'Change',
        'general.makeEnquiry': 'Make enquiry',
        name: 'Name',
        email: 'Email',
        tel: 'Tel',
        notAvailable: 'Not Available',
        menu: 'menu',
        dateCreated: 'Date created',
        startDate: 'Start Date',
        endDate: 'End Date',
        type: 'Type',
        view: 'View',
        'general.edit': 'Edit',
        'general.closeNotification': 'Close notification',
        'general.notification.details': 'notification details'
    },
    [LOCALES.WELSH]: {
        'general.signOut': 'Allgofnodi',
        'general.back': 'Yn ôl',
        'general.help': 'Help', // This has been translated into Welsh
        disagree: 'Anghytuno',
        agree: 'Cytuno',
        decline: 'Gwrthod',
        accept: 'Derbyn',
        retry: 'Ailgynnig',
        close: 'Cau',
        dismiss: 'Gwrthod',
        no: 'Nage',
        yes: 'Ie',
        ok: 'Iawn',
        errorLabel: 'Gwall',
        error: 'Ymddiheuriadau, rydym wedi dod ar draws gwall, rhowch gynnig arall arni',
        'general.error': 'Ymddiheuriadau, rydym wedi dod ar draws gwall, rhowch gynnig arall arni',
        loading: 'Llwytho',
        delete: 'Dileu',
        'general.cancel': 'Canslo',
        'general.continue': 'Parhad',
        'general.change': 'Newid',
        'general.makeEnquiry': '[Make enquiry]',
        name: 'Enw',
        email: 'E-bost',
        tel: 'Ffôn',
        notAvailable: 'Ddim ar gael',
        menu: 'dewislen',
        dateCreated: 'Dyddiad Creu',
        startDate: 'Dyddiad Dechrau',
        endDate: 'Dyddiad Gorffen',
        type: 'Math',
        view: 'Gweld',
        'general.edit': 'Golygu',
        'general.closeNotification': 'cau hysbysiad',
        'general.notification.details': 'manylion hysbysu'
    }
};
